import "./style.scss";

const ErrorPage = ({ testIntegration }: { testIntegration: boolean }) => {
  return (
    <div className={`error-container ${testIntegration ? "test-integration" : ""}`}>
      <div className="inner-err-container">
        <div className="wrong-text">
          <span className="main-text">{testIntegration ? "Mismatch / Invalid" : "ID Not"}</span>
          <span className="sub-text">{testIntegration ? "Workspace or domain" : "Found"}</span>
        </div>
        <img
          src="https://waymore.io/wp-content/uploads/2021/08/girl1copy.png"
          className="girl-img"
          alt=""
        />
      </div>
    </div>
  );
}

export default ErrorPage;
